import { Input, Slider, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type MaxRequiredFieldworkersFilterProps = {
    value: number | null;
    max: number;
    min?: number;
    onChange: (value: number | null) => void;
};

export function MaxRequiredFieldworkersFilter({ value, max, min = 1, onChange }: MaxRequiredFieldworkersFilterProps) {
    const { t } = useTranslation("plannerV2");

    const [sliderValue, setSliderValue] = useState<number | null>(null);

    return (
        <Stack paddingBottom={2}>
            <Typography>{t("maxRequiredFieldworkersFilter.label")}</Typography>
            <Stack direction="row" gap={2}>
                <Slider
                    min={min}
                    max={max}
                    value={sliderValue ?? value ?? max}
                    onChange={(_, newValue) => setSliderValue(Number(newValue))}
                    onChangeCommitted={(_, newValue) => onChange(Number(newValue))}
                    aria-label={t("maxRequiredFieldworkersFilter.sliderAriaLabel")}
                    valueLabelDisplay="auto"
                />
                <Input
                    key={value ?? max}
                    size="small"
                    type="number"
                    defaultValue={value ?? max}
                    inputProps={{ min, max }}
                    onChange={(event: { currentTarget: { value: string } }) => {
                        if (event.currentTarget.value === "") return;
                        const parsedValue = Number(event.currentTarget.value);
                        if (Number.isNaN(parsedValue)) return;
                        onChange(parsedValue);
                    }}
                />
            </Stack>
        </Stack>
    );
}
